import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("个人")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("企业")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("事业单位")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("增值税普通发票")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("增值税专用发票")

import { ref, Ref, reactive, onActivated, computed } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import router from '@/router/index'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber, formatFullTime } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/client_management/get_basic_info': get_basic_infoApi,
  // 获取财务客户联系人
  'POST/client_management/get_contacter': get_contacterApi,
  // 获取客户发票信息
  'POST/client_management/get_financial_info': get_financial_infoApi,
  // 获取财务客户提成信息
  'POST/client_management/get_commission': get_commissionApi,
  // 获取增值税发票信息
  'GET/client_management/vat/invoice/{username}': invoiceApi,
} = Api

const tabLoading = ref<boolean>(false)
const baseInfoObj: any = reactive({
  username: '', company: '', createTime: '', salesChannel: '', country: '',
  province: '', city: '', address: '', currency: '', email: '', phone: '',
  officialWebsite: '', customerType: '', paymentPeriod: '', independent: '',
})


const invoiceObj: any = reactive({
  date: '90', contacter: '', invoiceCompany: '', bankAddressList: '',
})
const taxAddedObj: any = reactive({
  username: '',
  buyerName: '',
  titleType: '',
  invoiceType: '',
  keyCode: '',
  bankName: '',
  bankAccount: '',
  registerAddress: '',
  registerPhone: '',
})

const baseParams = computed(() => {
  let {id} = router.currentRoute.value.params
  return {
    username: id
  }
})

let contactList: any = ref([])
let commissionList: any = ref([])
onActivated(() => {
  let {id} = router.currentRoute.value.params
  get_basic_infoApi(baseParams.value, {contentType: 'formData'}).then((rep: any) => {
    Object.assign(baseInfoObj, rep)
  })
  // 获取联系人
  get_contacterApi(baseParams.value, {contentType: 'formData'}).then((rep: any) => {
    contactList.value = rep
  })
  // 获取发票
  get_financial_infoApi(baseParams.value, {contentType: 'formData'}).then((rep: any) => {
    Object.assign(invoiceObj, rep)
  })
  // 提成
  get_commissionApi(baseParams.value, {contentType: 'formData'}).then((rep: any) => {
    commissionList.value = [
      {type: '销售员：', name: rep.operator, ratio: rep.operatorRatio},
      {type: '项目经理：', name: rep.pm, ratio: rep.pmRatio},
      {type: 'AM：', name: rep.am, ratio: rep.amRatio},
      {type: '销售渠道：', name: rep.independent, ratio: ''},
      {type: 'share：', name: rep.share, ratio: rep.shareRatio},
      {type: '备注：', name: rep.note},
    ]
  })
  // 增值税发票
  invoiceApi(baseParams.value).then((rep: any) => {
    Object.assign(taxAddedObj, rep)
  })
})

const arraySpanMethod = ({row, column, rowIndex, columnIndex,}) => {
  if (rowIndex === 5) {
    if (columnIndex === 1) {
      return [1, 2]
    } else if (columnIndex === 2) {
      return [0, 0]
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      class: "mb-10 mt-10",
      type: "info",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({path: '/financial-customer'})))
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_tabs, { type: "border-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, { label: "基本信息" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              "label-position": "top",
              inline: true,
              disabled: "",
              model: _unref(baseInfoObj),
              "label-width": "90px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "用户名:",
                  prop: "username"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: _unref(baseInfoObj).username,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(baseInfoObj).username) = $event)),
                      class: "form-input",
                      maxlength: "200"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "客户名:",
                  prop: "company"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: _unref(baseInfoObj).company,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(baseInfoObj).company) = $event)),
                      class: "form-input",
                      maxlength: "200"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "记录日期:",
                  prop: "createTime"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(baseInfoObj).createTime,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(baseInfoObj).createTime) = $event)),
                      "value-format": "YYYY-MM-DD"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "CRM平台:",
                  prop: "salesChannel"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: _unref(baseInfoObj).salesChannel,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(baseInfoObj).salesChannel) = $event)),
                      class: "form-input",
                      maxlength: "200"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "国家:",
                  prop: "country"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: _unref(baseInfoObj).country,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(baseInfoObj).country) = $event)),
                      class: "form-input",
                      maxlength: "200"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "省份:",
                  prop: "province"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: _unref(baseInfoObj).province,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(baseInfoObj).province) = $event)),
                      class: "form-input",
                      maxlength: "200"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "城市:",
                  prop: "city"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: _unref(baseInfoObj).city,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(baseInfoObj).city) = $event)),
                      class: "form-input",
                      maxlength: "200"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "地址:",
                  prop: "address"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: _unref(baseInfoObj).address,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(baseInfoObj).address) = $event)),
                      class: "form-input",
                      maxlength: "200"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "货币:",
                  prop: "currency"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: _unref(baseInfoObj).currency,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(baseInfoObj).currency) = $event)),
                      class: "form-input",
                      maxlength: "200"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "电话:",
                  prop: "phone"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: _unref(baseInfoObj).phone,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(baseInfoObj).phone) = $event)),
                      class: "form-input",
                      maxlength: "200"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "网站:",
                  prop: "officialWebsite"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: _unref(baseInfoObj).officialWebsite,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(baseInfoObj).officialWebsite) = $event)),
                      class: "form-input",
                      maxlength: "200"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "客户性质:",
                  prop: "customerType"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: _unref(baseInfoObj).customerType,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(baseInfoObj).customerType) = $event)),
                      class: "form-input",
                      maxlength: "200"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "销售渠道:",
                  prop: "independent"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: _unref(baseInfoObj).independent,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(baseInfoObj).independent) = $event)),
                      class: "form-input",
                      maxlength: "200"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, { label: "联系人" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              data: _unref(contactList),
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, { type: "index" }),
                _createVNode(_component_el_table_column, {
                  prop: "name",
                  label: "姓名"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "title",
                  label: "岗位"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "email",
                  label: "Eamil"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "phone",
                  label: "电话"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "mobile",
                  label: "手机"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "note",
                  label: "备注"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "createTime",
                  label: "记录日期",
                  formatter: _unref(formatFullTime)
                }, null, 8, ["formatter"])
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, { label: "发票信息" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tabs, { "tab-position": "left" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, { label: "Invoice" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form, {
                      "label-position": "left",
                      inline: false,
                      disabled: "",
                      model: _unref(invoiceObj),
                      "label-width": "110px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "发票主体:",
                          prop: "invoiceCompany"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              clearable: "",
                              modelValue: _unref(taxAddedObj).invoiceCompany,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(taxAddedObj).invoiceCompany) = $event)),
                              style: {"width":"550px"},
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "发票地址:",
                          prop: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              clearable: "",
                              modelValue: _unref(invoiceObj).invoiceAddress,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(invoiceObj).invoiceAddress) = $event)),
                              style: {"width":"550px"},
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "付款周期:",
                          prop: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              clearable: "",
                              modelValue: _unref(invoiceObj).paymentCycle,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(invoiceObj).paymentCycle) = $event)),
                              style: {"width":"550px"},
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "支付方式:",
                          prop: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              clearable: "",
                              modelValue: _unref(invoiceObj).paymentWay,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(invoiceObj).paymentWay) = $event)),
                              style: {"width":"550px"},
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "联系人:",
                          prop: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              clearable: "",
                              modelValue: _unref(invoiceObj).contacter,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(invoiceObj).contacter) = $event)),
                              style: {"width":"550px"},
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "标准回款期:",
                          prop: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              clearable: "",
                              modelValue: _unref(invoiceObj).date,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(invoiceObj).date) = $event)),
                              style: {"width":"550px"},
                              maxlength: "200",
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "收款银行:",
                          prop: "bankAddressList"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "textarea",
                              rows: 4,
                              modelValue: _unref(invoiceObj).bankAddressList,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(invoiceObj).bankAddressList) = $event)),
                              style: {"width":"550px"},
                              maxlength: "500"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, { label: "增值税发票" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form, {
                      "label-position": "left",
                      inline: false,
                      disabled: "",
                      model: _unref(taxAddedObj),
                      "label-width": "150px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "购买方名称:",
                          prop: "buyerName"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              clearable: "",
                              modelValue: _unref(invoiceObj).buyerName,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(invoiceObj).buyerName) = $event)),
                              style: {"width":"550px"},
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "抬头类型:",
                          prop: "titleType"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_group, {
                              modelValue: _unref(taxAddedObj).titleType,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(taxAddedObj).titleType) = $event)),
                              class: "ml-4"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_radio, { label: "INDIVIDUAL" }, {
                                  default: _withCtx(() => [
                                    _hoisted_2
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_radio, { label: "ENTERPRISE" }, {
                                  default: _withCtx(() => [
                                    _hoisted_3
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_radio, { label: "PUBLIC_INSTITUTION" }, {
                                  default: _withCtx(() => [
                                    _hoisted_4
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "默认发票类型:",
                          prop: "invoiceType"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_group, {
                              modelValue: _unref(taxAddedObj).invoiceType,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(taxAddedObj).invoiceType) = $event)),
                              class: "ml-4"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_radio, { label: "ORDINARY" }, {
                                  default: _withCtx(() => [
                                    _hoisted_5
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_radio, { label: "SPECIAL" }, {
                                  default: _withCtx(() => [
                                    _hoisted_6
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "购买方纳税人识别号:",
                          prop: "keyCode"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              clearable: "",
                              modelValue: _unref(taxAddedObj).keyCode,
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(taxAddedObj).keyCode) = $event)),
                              style: {"width":"550px"},
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "购买方开户银行:",
                          prop: "bankName"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              clearable: "",
                              modelValue: _unref(taxAddedObj).bankName,
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(taxAddedObj).bankName) = $event)),
                              style: {"width":"550px"},
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "购买方银行账号:",
                          prop: "bankAccount"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              clearable: "",
                              modelValue: _unref(taxAddedObj).bankAccount,
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(taxAddedObj).bankAccount) = $event)),
                              style: {"width":"550px"},
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "购买方地址:",
                          prop: "registerAddress"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              clearable: "",
                              modelValue: _unref(taxAddedObj).registerAddress,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(taxAddedObj).registerAddress) = $event)),
                              style: {"width":"550px"},
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "购买方电话:",
                          prop: "registerPhone"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              clearable: "",
                              modelValue: _unref(taxAddedObj).registerPhone,
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(taxAddedObj).registerPhone) = $event)),
                              style: {"width":"550px"},
                              maxlength: "200",
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, { label: "提成管理" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              data: _unref(commissionList),
              "show-header": false,
              border: "",
              style: {"width":"600px"},
              "span-method": arraySpanMethod
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "",
                  prop: "type"
                }),
                _createVNode(_component_el_table_column, {
                  label: "",
                  prop: "name"
                }),
                _createVNode(_component_el_table_column, {
                  label: "",
                  prop: "ratio"
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })), [
      [_directive_loading, tabLoading.value]
    ])
  ]))
}
}

})